import type { BosatlasDto } from "../models/models"
import type { HttpResponse } from "../redux/http/http.types"
import { populateBundleDates } from "./BundleService"
import { get } from "./HttpService"

export async function getBosatlas(): Promise<BosatlasDto> {
  const response: HttpResponse<BosatlasDto> = await get<BosatlasDto>("bosAtlas", "MyBosatlas")
  const bosatlas: BosatlasDto = response.data!
  bosatlas.bundles = bosatlas.bundles?.map(populateBundleDates)
  return bosatlas
}

export async function getBosatlasSearchSuggestions(searchValue: string): Promise<string[]> {
  const response: HttpResponse<string[]> = await get<string[]>(
    "bosatlas",
    `mybosatlas/autocomplete?searchvalue=${searchValue}`
  )

  return response.data!
}

export async function searchBosatlas(searchValue: string): Promise<BosatlasDto> {
  const response: HttpResponse<BosatlasDto> = await get<BosatlasDto>(
    "bosatlas",
    `mybosatlas/search?searchvalue=${searchValue}`
  )
  const bosatlas: BosatlasDto = response.data!

  bosatlas.bundles = bosatlas.bundles?.map(populateBundleDates)
  return bosatlas
}
